export default function($) {
  $('.js-search-trigger').on('click', function(){
    $('.js-search-bar').toggleClass('max-h-0');
    $('.js-search-bar').toggleClass('max-h-[250px]');
    $('this').toggleClass('fill-white');
    $('this').toggleClass('fill-primary');
  })
}
